// @flow
import {connect} from 'react-redux';
import config from '../../../config';
import {addOptionToNewOffer} from '../../../modules/NewOffer/actions';
import {
  hasRoamingCreditableOptions,
} from '../../../modules/AvailableOption/selectors';
import {newOfferOptionsSelector} from '../../../modules/NewOffer/selectors';
import StepperPlanSliders from './StepperPlanSliders';

const mapStateToProps = state => {
  const newOfferOptions = newOfferOptionsSelector(state);
  return {
    hasRoamingOptions: hasRoamingCreditableOptions(state),
    localDataOption: newOfferOptions.find(o => o.type === 'DATA'),
    roamingDataOption: newOfferOptions.find(o =>
      (config.roamingDataServiceSpecs || []).includes(o.type),
    ),
  };
};

const mapDispatchToProps = dispatch => ({
  removeOptionFromNewOffer: option => dispatch(addOptionToNewOffer(undefined, option)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StepperPlanSliders);
